import React from "react";
import { Table, Button } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FormattedMessage, useIntl } from "react-intl";
import ButtonSendActivationMail from "../Button/ButtonSendActivationMail";
import { compareByName } from "../../Utilities/sortHelper";

const TeacherTable = (props) => {
  const intl = useIntl();
  var teachers = props.teachers;

  if (props.filter && props.filter.length > 0) {
    teachers = props.teachers.filter((t) => {
      return (
        t.name.toLowerCase().indexOf(props.filter) !== -1 ||
        t.email.toLowerCase().indexOf(props.filter) !== -1
      );
    });
  }

  teachers = [...teachers].sort(compareByName);

  var mappedTeachers = teachers.map((teacher, id) => {
    // Samma markering som i StudentTable: ej aktiverat konto dämpar radens text.
    // Knapparna har egna färger och påverkas inte; namnknappen ärver radens
    // färg via name-link.
    const notActivated = !teacher.activatedAccount;

    return (
      <tr
        key={id}
        style={{ verticalAlign: "middle" }}
        className={notActivated ? "row-not-activated" : undefined}
        title={
          notActivated ? intl.formatMessage({ id: "NotActivated" }) : undefined
        }
      >
        <td>{teacher.id}</td>
        <td>
          <Button
            className="ps-0 text-start name-link"
            color="link"
            disabled={!props.fullAccess}
            onClick={() => props.updateTeacher(teacher)}
            title={
              props.fullAccess
                ? intl.formatMessage({ id: "ClickToUpdateTeacher" }, { name: teacher.name })
                : intl.formatMessage({ id: "NoPermissionToUpdateOtherTeachers" })
            }
          >
            {teacher.name}
          </Button>
          {notActivated && (
            <span className="visually-hidden">
              <FormattedMessage id="NotActivated" />
            </span>
          )}
        </td>
        <td>{teacher.email}</td>
        <td>
          <FormattedMessage id={teacher.purchaser ? "Yes" : "No"} />
        </td>
        <td>
          <FormattedMessage id={teacher.fullAccess ? "Yes" : "No"} />
        </td>
        <td>
          <ButtonSendActivationMail className="float-end" user={teacher} />
        </td>
        <td>
          <Button
            hidden={props.editable === false}
            onClick={() => props.detachTeacher(teacher)}
            size="sm"
            color="danger"
            outline
            className={"float-end"}
          >
            <FontAwesomeIcon icon="trash" />
          </Button>
        </td>
      </tr>
    );
  });

  return (
    <Table hover responsive striped className="school-table">
      <thead>
        <tr>
          <th>Id</th>
          <th hidden={!props.selectable} />
          <th><FormattedMessage id="Name" /></th>
          <th><FormattedMessage id="Email" /></th>
          <th><FormattedMessage id="Purchaser" /></th>
          <th><FormattedMessage id="FullAccess" /></th>
          <th />
          <th />
        </tr>
      </thead>
      <tbody>{mappedTeachers}</tbody>
    </Table>
  );
};

export default TeacherTable;
